export default __webpack_public_path__ + "static/media/profielBackgoundImage.ddc97c46.jpg";